/**
 * Stats 统计页：日期范围选择 + StatsCharts（纯 CSS 条形图）。
 * useStats(from?, to?) → StatsResult。
 */
import { useState } from 'react';
import { useStats } from '../hooks/useTasks';
import { StatsCharts } from '../components/StatsCharts';
import { Card, Button, Input, LoadingBlock, ErrorBox } from '../components/ui';

function monthStart(): string {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-01`;
}
function todayStr(): string {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
}

const PRESETS: { label: string; from: () => string; to: () => string }[] = [
  { label: '本周', from: () => { const d = new Date(); d.setDate(d.getDate() - d.getDay() + 1); return d.toISOString().slice(0, 10); }, to: todayStr },
  { label: '本月', from: monthStart, to: todayStr },
  { label: '近 30 天', from: () => { const d = new Date(); d.setDate(d.getDate() - 29); return d.toISOString().slice(0, 10); }, to: todayStr },
];

export function StatsPage() {
  const [from, setFrom] = useState<string | undefined>(monthStart());
  const [to, setTo] = useState<string | undefined>(todayStr());
  const { data: stats, isLoading, error } = useStats(from, to);

  return (
    <div className="space-y-4">
      <div>
        <h1 className="text-2xl font-bold">统计</h1>
        <p className="mt-1 text-sm text-slate-500 dark:text-slate-400">
          任务完成情况、习惯连续记录与专注时长
        </p>
      </div>

      <Card className="p-4">
        <div className="flex flex-wrap items-end gap-3">
          <div>
            <label className="mb-1 block text-xs font-medium text-slate-500 dark:text-slate-400">
              开始日期
            </label>
            <Input
              type="date"
              value={from ?? ''}
              onChange={(e) => setFrom(e.target.value || undefined)}
              className="w-40"
            />
          </div>
          <div>
            <label className="mb-1 block text-xs font-medium text-slate-500 dark:text-slate-400">
              结束日期
            </label>
            <Input
              type="date"
              value={to ?? ''}
              onChange={(e) => setTo(e.target.value || undefined)}
              className="w-40"
            />
          </div>
          {PRESETS.map((p) => (
            <Button
              key={p.label}
              variant="secondary"
              size="sm"
              onClick={() => { setFrom(p.from()); setTo(p.to()); }}
            >
              {p.label}
            </Button>
          ))}
          <Button
            variant="ghost"
            size="sm"
            onClick={() => { setFrom(undefined); setTo(undefined); }}
          >
            全部时间
          </Button>
        </div>
      </Card>

      {isLoading && <LoadingBlock text="统计计算中…" />}
      {error && <ErrorBox error={error} />}
      {stats && <StatsCharts stats={stats} />}
    </div>
  );
}
